const roleEnum = Object.freeze({
    ADMIN       : 1,
    CUSTOMER    : 2,
    MANAGER     : 3,
    POS_OPERATOR: 4,
    STAFF       : 5
});

export default roleEnum;
